import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <h4 className="text-white font-heading text-xl mb-4">茄子视频</h4>
              <p className="text-sm leading-relaxed text-foreground-400">
                茄子视频是一款深受用户喜爱的短视频娱乐平台，海量搞笑、生活、才艺视频等你来看。
              </p>
            </div>

            <div>
              <h4 className="text-white font-medium text-sm mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">首页</Link></li>
                <li><Link to="/category" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">视频分类</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-medium text-sm mb-4">热门分类</h4>
              <ul className="space-y-2">
                <li><Link to="/category?cat=comedy" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">搞笑视频</Link></li>
                <li><Link to="/category?cat=lifestyle" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">生活记录</Link></li>
                <li><Link to="/category?cat=talent" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">才艺展示</Link></li>
                <li><Link to="/category?cat=food" className="text-sm text-foreground-400 hover:text-white cursor-pointer transition-colors">美食分享</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-medium text-sm mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  <span>contact@qiezitv.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                  <span>北京市朝阳区茄子大厦</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 茄子视频 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-white cursor-pointer transition-colors">隐私政策</a>
              <a href="#" className="hover:text-white cursor-pointer transition-colors">用户协议</a>
              <a href="#" className="hover:text-white cursor-pointer transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}